import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IosPeople from '@meronex/icons/ios/IosPeople';

import AddTeamDialog from './AddTeamDialog';
import EditTeamDialog from './EditTeamDialog';
import TeamsList from './TeamsList';
import TopHeader from '../../../views/components/TopHeader';

import { teamsMng } from '../api/teamsMng';

function TeamsDialog(props) {
  const { open, onClose } = props;

  const [openAddTeam, setOpenAddTeam] = React.useState(false);
  const [openEditTeam, setOpenEditTeam] = React.useState(false);
  const [selectedTeam, setSelectedTeam] = React.useState();
  const [teams, setTeams] = React.useState();

  const getTeams = async () => {
    const teams = await teamsMng.getTeams();
    setTeams(teams);
  };

  React.useEffect(() => {
    getTeams();
  }, []);

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        <TopHeader
          title={'Teams'}
          onClose={onClose}
          icon={<IosPeople size={20} />}
          actionLabel={'Add Team'}
          onAction={() => {
            setSelectedTeam(false);
            setOpenAddTeam(true);
          }}
        />
      </DialogTitle>
      <DialogContent style={{ padding: '0px' }}>
        <TeamsList
          teams={teams}
          onEdit={(team) => {
            setSelectedTeam(team);
            setOpenEditTeam(true);
          }}
          onDelete={getTeams}
        />
      </DialogContent>
      {openAddTeam && (
        <AddTeamDialog
          open={openAddTeam}
          onAdd={getTeams}
          onClose={() => {
            setOpenAddTeam(false);
            setSelectedTeam(null);
          }}
        />
      )}
      {openEditTeam && (
        <EditTeamDialog
          open={openEditTeam}
          team={selectedTeam}
          onEdit={getTeams}
          onClose={() => {
            setOpenEditTeam(false);
            setSelectedTeam(false);
          }}
        />
      )}
    </Dialog>
  );
}

TeamsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default TeamsDialog;
